import axios from "../axios";

export const saveLearnerForm = async (learner) => {
	return await axios.post("/api/learner", learner);
};

export const submitLearnerAnswer = async (answer) => {
	return await axios.post("/api/learner/submit-answer", answer);
};

export const submitCourseReady = async (data) => {
	return await axios.post("/api/learner/submit-course-ready", data);
};

export const completeLater = async (data) => {
	try {
		return await axios.post("/api/learner/complete-later", data);
	} catch (e) {
		return false;
	}
};

export const getLearner = async (invite) => {
	try {
		const learner = await axios.get(`/api/learner?invite=${invite}`);
		if (learner.status === 200) {
			return { learner: learner?.data?.data };
		}
		return false;
	} catch (e) {
		return false;
	}
};
